import { useContext } from "react";

import { DesktopBridgeContext } from "./desktop-bridge.context.js";

export const useDesktopBridge = () => {
  const context = useContext(DesktopBridgeContext);

  if (!context.__ctx_init) {
    throw new Error(
      "useDesktopBridge must be used within a DesktopBridgeProvider"
    );
  }

  return context;
};
